const defaultPlanSelection = {
    house_type: [],
    bedrooms: [],
    bathrooms: [],
    minimum_plot_size: [],
};
Object.freeze(defaultPlanSelection);

export default defaultPlanSelection;
